





































import { Vue, Component, Prop } from 'vue-property-decorator';
import CartHeader from '@/components/cart/CartHeader.vue';
import CartItem from '@/components/cart/CartItem.vue';
import CartDetailedFooter from '@/components/cart/CartDetailedFooter.vue';
import { OrderReceiptItemModel, OrderReceiptModel } from '@/models/OrderReceiptModel';
import { CartItemExtraView } from '@/types';

@Component({
  components: {
    CartDetailedFooter,
    CartItem,
    CartHeader,
  },
})
export default class ReceiptCart extends Vue {
  private isExpanded = false;

  @Prop() private readonly receipt!: OrderReceiptModel;

  private get receiptItemViews(): Array<OrderReceiptItemModel & { extraViews: CartItemExtraView[] }> {
    return this.receipt.items.map((e) => ({
      ...e,
      extraViews: e.extras.map((s) => ({
        id: s.itemExtraListItemId,
        unitPrice: s.unitPrice,
        name: s.extraOptionName,
      })),
    }));
  }
}
